import toastr from 'toastr'

toastr.options.toastClass = 'b-toasts styled'
toastr.options.iconClasses = {
  success: 'success',
  info: 'success',
  error: 'error',
  warning: 'warning'
}

export default toastr
